import type { PropsWithChildren } from "react";

export const HeaderRightPanel = ({
  children,
}: PropsWithChildren<Record<string, unknown>>) => (
  <div className="ml-auto flex flex-row items-center gap-2">{children}</div>
);
